'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormItemLabelStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};

/** PROP RECEIVERS */
var baseProps = function baseProps(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.formItem.label,
      color = _theme$reactackle$com.color,
      fontSize = _theme$reactackle$com.fontSize,
      lineHeight = _theme$reactackle$com.lineHeight,
      textTransform = _theme$reactackle$com.textTransform,
      fontWeight = _theme$reactackle$com.fontWeight,
      marginBottom = _theme$reactackle$com.marginBottom;


  return '\n    color: ' + color + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    text-transform: ' + textTransform + ';\n    font-weight: ' + fontWeight + ';\n    margin-bottom: ' + (0, _reactackleCore.getValueString)(marginBottom) + ';\n  ';
};

/** EXPORT STYLES */
var FormItemLabelStyled = exports.FormItemLabelStyled = _styledComponents2.default.div.withConfig({
  displayName: 'FormItemLabelStyled'
})(['display:flex;flex-direction:column;justify-content:center;user-select:none;', ' ', ';'], baseProps, (0, _reactackleCore.transition)('color'));

FormItemLabelStyled.propTypes = propTypes;
FormItemLabelStyled.displayName = 'FormItemLabelStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-form/dist/FormItem/FormItemLabel/styles/FormItemLabelStyled.js
// module id = 675
// module chunks = 0